import { storeData } from "./materials-store-data"
import { freeData } from "./materials-free-data"

export const multiData = [
  ...storeData,
  ...freeData
];